var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDictionary = function SvgDictionary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.987 2.917-.59-1.955a.522.522 0 0 0-.28-.962H4.058c-.543 0-1.04.222-1.395.578a1.966 1.966 0 0 0-.578 1.395V14.71c0 .712.577 1.289 1.289 1.289h9.453c.6 0 1.086-.486 1.086-1.085V3.987c0-.546-.403-.992-.927-1.07ZM4.06 2.901a.924.924 0 0 1-.657-.272.924.924 0 0 1 0-1.313.923.923 0 0 1 .657-.272h7.562l.562 1.857H4.059Z",
    fill: "#999"
  })));
};
export default SvgDictionary;